var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP4RBusinessMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8,16 H40 V40 H8 Z",
    fill: "#7C1CFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5,18 L24,5 L43,18 L39,22 L24,12 L9,22 Z",
    fill: "#FFD000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14,22 H22 V31 H14 Z M27,22 H35 V31 H27 Z M20,33 H29 V40 H20 Z",
    fill: "#FFFFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36,7 A4,4 0,1 0,36,15 A4,4 0,1 0,36,7",
    fill: "#00D4FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP4RBusinessMain);
export default __webpack_public_path__ + "static/media/p4r_business_main.fc72efdb506c0af271cf2c50a9a5c0ae.svg";
export { ForwardRef as ReactComponent };